<ion-header>
  <ion-toolbar>
    <img src="assets/icon/cona.png" alt="cona icon" slot="start" />
    <div class="title" *ngIf="!isProduction">
      UAT Application
    </div>

    <ion-buttons slot="end">
      <ion-button class="profile" shape="round" (click)="togglePopover($event)">
        <img *ngIf="avatar" [src]="avatar" alt="profile img" />
        <div slot="start" #avatarHolder></div>
        <span>{{ userName }}</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- Profile Popover -->
<ion-popover
  *ngIf="showPopover"
  [isOpen]="showPopover"
  (didDismiss)="closePopover()"
  class="profile-popover"
  style="padding: 16px 0"
>
  <ng-template>
    <ion-content>
      <ion-list class="profile-dropdown">
        <ion-item lines="none" class="no-right-padding">
          <div class="profile-details">
            <ion-avatar>
              <img style="min-height: 100%; width: auto !important" *ngIf="avatar" [src]="avatar" alt="profile img" />
              <div style="min-height: 68px; width: 68px !important" #avatarInnerHolder></div>
            </ion-avatar>
            <ion-label>
              <h2>{{ userName }}</h2>
              <p class="email">{{ userEmail }}</p>
              <p>{{ userPhone }}</p>
            </ion-label>
          </div>
        </ion-item>
        <ion-item lines="none" button (click)="openSettings()" *ngIf="isVisible()">
          <ion-icon name="settings-outline"></ion-icon>
          <ion-label style="margin: 5px">Settings</ion-label>
        </ion-item>
        <ion-item lines="none" (click)="logout()">
          <ion-icon name="log-out-outline"></ion-icon>
          <ion-label style="margin: 2px">Log Out</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>
<app-overlay *ngIf="settingsOpen"></app-overlay>
<app-settings
  *ngIf="settingsOpen"
  [role]="role"
  [bottlerId]="bottlerId"
  [initialTab]="initialSettingsTab"
  (openSettings)="closeSettings($event)"
  (settingsSaved)="onSettingsSaved()"
></app-settings>
